import BaseResource from './index'

export default class GroupResource extends BaseResource {
    static endpoint = '/groups'
}
